import './CodexPlaceholder.css'

function CodexPlaceholder() {
  return (
    <section className="codex-placeholder" aria-live="polite">
      <div className="codex-placeholder-card">
        <p className="codex-placeholder-kicker">Codex</p>
        <h2 className="codex-placeholder-title">Contenu en cours de construction</h2>
        <p className="codex-placeholder-text">
          Le Codex est temporairement vide. Il sera enrichi progressivement.
        </p>
      </div>
    </section>
  )
}

export default CodexPlaceholder
